import React from 'react';
import { Table } from '@exxonmobil/react-unity';
import styled from 'styled-components';
import { ErrorBox } from '../../common/components/ErrorBox';
import { StatusBadge } from '../../common/components/StatusBadge';
import { StyledTable, TableBodyRow, TableCell, TableHeadRow } from '../../common/components/TableComponents';
import { DataTableLoading } from '../../common/components/TableLoading';
import { ComponentValidation } from '../../common/types/DomainDetailTypes';

interface Props {
  components: ComponentValidation[];
  isLoading: boolean;
  error: string;
  titles: string[];
  onRefresh: () => void;
}

const DataHeaders = ({ titles }: { titles: string[] }) => (
  <Table.Head>
    <TableHeadRow style={{ height: '2px' }}>
      {titles.map((title, idx) => (
        <Table.Head.Cell key={idx}>{title}</Table.Head.Cell>
      ))}
    </TableHeadRow>
  </Table.Head>
);

const DataRows = ({ components }: { components: ComponentValidation[] }) => (
  <Table.Body>
    {components.map((component) => (
      <TableBodyRow key={component.id}>
        <StyledTableCell>
          <TextContainer>{component.name}</TextContainer>
        </StyledTableCell>
        <TableCell>
          <StatusBadge status={component.status} />
        </TableCell>
      </TableBodyRow>
    ))}
  </Table.Body>
);

const getTableContent = (
  error: string,
  onRefresh: () => void,
  isLoading: boolean,
  components: ComponentValidation[]
) => {
  if (error) {
    if (error === '401' || error === '403') {
      return <EmptyDataContainer>Sessions timeout, please close the page and login again.</EmptyDataContainer>;
    }
    return <ErrorBox onRefresh={onRefresh} isRefreshable />;
  }
  if (isLoading) {
    return <DataTableLoading rowNumber={5} columnSpan={1} />;
  }
  if (components.length === 0) {
    return <EmptyDataContainer>No data available in table</EmptyDataContainer>;
  }
  return <DataRows components={components} />;
};

const ServicesTable = ({ components, isLoading, error, titles, onRefresh }: Props) => (
  <DetailTable striped>
    <DataHeaders titles={titles} />
    {getTableContent(error, onRefresh, isLoading, components)}
  </DetailTable>
);

const EmptyDataContainer = styled.div`
  text-align: center;
  padding-top: 2rem;
  min-height: 5rem;
`;

const DetailTable = styled(StyledTable)``;

const StyledTableCell = styled(TableCell)`
  display: flex;
  flex-direction: row;
`;

const TextContainer = styled.p`
  line-height: 36px;
  margin-bottom: 0;
`;

export default ServicesTable;
